var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrentRocketsSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.4 231.3",
    style: {
      enableBackground: "new 0 0 212.4 231.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .tr-st0{fill:#F53C00;}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.1,219.5h72.2l-42.8-70.6l39.2-49l-9-22.3L11.8,158.7v60.7h68.6v-63.4L119.1,219.5L119.1,219.5z M212.4,231.3h-99.8 l-20.3-33.5v33.5H0v-80l185.1-90l16.3,40.5l-38.4,48L212.4,231.3z M11.9,108.4l142.5-96.5H11.9V108.4z M0,130.7V0h160.6l6.8,17.3 L0,130.7L0,130.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "tr-st0",
    d: "M38.6,119.7l151.3-74.9l-8.5-21L38.2,118.8L38.6,119.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrentRocketsSymbol);
export default __webpack_public_path__ + "static/media/trent-rockets-symbol.72fec4ab.svg";
export { ForwardRef as ReactComponent };